var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovementUsda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1051,
    height: 1051,
    viewBox: "0 0 1051 1051",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 525.5,
    cy: 525.5,
    r: 525.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.941 354.629H523.459L368.256 696.625H299.738L454.941 354.629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M592.013 354.629H523.495L678.697 696.625H747.215L592.013 354.629Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M522.899 523.542L591.298 697.217H454.5L522.899 523.542Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M900.106 578.282C873.681 761.093 716.355 901.547 526.224 901.547C336.093 901.547 178.767 761.093 152.341 578.282H93.4219C120.252 793.443 303.795 959.936 526.224 959.936C748.653 959.936 932.196 793.443 959.026 578.282H900.106Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.341 469.238C178.767 286.426 336.093 145.972 526.224 145.972C716.355 145.972 873.681 286.426 900.106 469.238H959.026C932.196 254.076 748.653 87.583 526.224 87.583C303.795 87.583 120.252 254.076 93.4219 469.238H152.341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementUsda);
export default __webpack_public_path__ + "static/media/movement-usda.1088e1397558dc7c97fca13ac73c2fea.svg";
export { ForwardRef as ReactComponent };